import { capitalize } from 'lodash'
import React, { FC, useCallback, useEffect, useState } from 'react'
import 'react-h5-audio-player/lib/styles.css'
import { pdfjs } from 'react-pdf'
import { useDispatch } from 'react-redux'
import { RouteComponentProps, useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { setPageTitle, setPreviousPage } from 'src/ducks/onDemand'
import routes from 'src/routes'
import Amplitude from 'src/utils/amplitudeHelper'
import { get, ON_DEMAND_APIS } from '../../../apis/onDemandApi'
import { Loader } from '../../shared/Loader'
import { OralPresentation } from '../OralPresentation'
import { PosterPresentation } from '../PosterPresentation'
import { abstractPoster } from '../posters'
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js'

export interface AbstractType {
  id?: number
  title?: string
  submission_type?: 'poster' | 'oral'
  presenter_email?: string
  presenting_author_name?: string
  area_of_interest?: string
  audio_recording?: {
    url: string
  }
  poster?: {
    url: string
  }
  vimeo_video?: {
    vimeo_id: string
  }
  award_type?: string
}

const pageTitle: { [key in AbstractType['submission_type']]: string } = {
  poster: 'E-Poster Presentation',
  oral: 'Oral Presentation',
}

const submissionTypePage: { [key in AbstractType['submission_type']]: string } = {
  poster: routes.onDemandPoster,
  oral: routes.onDemandOral,
}

export const PresentationContainer: FC<RouteComponentProps> = ({ match }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [abstract, setAbstract] = useState<AbstractType>({})
  const [hasRated, setHasRated] = useState(false)
  const [pageLoading, setPageLoading] = useState<boolean>(false)

  const abstractId = match.params['abstractId']

  useEffect(() => {
    dispatch(setPageTitle("E-Gallery"))
    dispatch(setPreviousPage(routes.onDemand))
  }, [dispatch])

  const getAbstract = useCallback(() => {
    // setPageLoading(true)
    const selected = abstractPoster.filter(abstract => abstract.id == abstractId)[0]
    setAbstract(selected)
    Amplitude.viewAbstractPresentation(selected)
    // get(
    //   ON_DEMAND_APIS.GET_ABSTRACT(abstractId),
    //   (result) => {
    //     setPageLoading(false)
    //     if (result.success) {
    //       const abstractResult: AbstractType = result.abstract
    //       setAbstract(abstractResult)
    //       setHasRated(result.rated)
    //       Amplitude.viewAbstractPresentation(abstractResult, capitalize(abstractResult.submission_type))
    //     } else {
    //       toast('This abstract does not exist', { toastId: 'abstract-not-exist' })
    //       history.push(routes.onDemand)
    //     }
    //   },
    //   (error) => {
    //     setPageLoading(false)
    //     toast('Unable to display this abstract. Please try again later.')
    //     history.push(routes.onDemand)
    //     console.error(error)
    //   }
    // )
  }, [abstractId, history])

  useEffect(() => {
    getAbstract()
  }, [getAbstract])

  const renderAbstract = () => {
    // if (abstract.submission_type === 'oral') {
    //   return <OralPresentation hasRated={hasRated} abstract={abstract} />
    // }

    // if (abstract.submission_type === 'poster') {
    //   return <PosterPresentation hasRated={hasRated} abstract={abstract} />
    // }
    return <PosterPresentation hasRated={hasRated} abstract={abstract} />

  }

  return (
    <Loader fullPage loading={pageLoading}>
      {renderAbstract()}
    </Loader>
  )
}
